import { render, staticRenderFns } from "./manage-documents.vue?vue&type=template&id=3b0bf035&"
import script from "./manage-documents.vue?vue&type=script&lang=js&"
export * from "./manage-documents.vue?vue&type=script&lang=js&"
import style0 from "./manage-documents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports